import { render } from "./FiltersSummary.vue?vue&type=template&id=db96cd3a"
import script from "./FiltersSummary.vue?vue&type=script&lang=js"
export * from "./FiltersSummary.vue?vue&type=script&lang=js"
script.render = render

export default script